export const userReducer = (state = {}, action) => {
    switch (action.type) {
        case "SETUSER":
            return { ...action.payload };
        case "CLEARUSER":
            return { ...action.payload };
        default:
            return state;
    }
}